import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { untilDestroyed } from '@ngneat/until-destroy';
import { Subject, tap } from 'rxjs';

@Directive()
export abstract class SideNavItemBaseComponent implements OnInit, OnDestroy {

    public static attached$ = new Subject<SideNavItemBaseComponent>();
    public open = false;
    public active = false;

    constructor(
        protected cdr: ChangeDetectorRef,
    ) {
        SideNavItemBaseComponent
            .attached$
            .pipe(
                takeUntilDestroyed(),
                tap(x => {
                    if (x !== this) {
                        this.open = false;
                    }
                    this.cdr.detectChanges();

                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {

    }

    onAttached() {
        SideNavItemBaseComponent.attached$.next(this);
    }

    onForceClose() {
        SideNavItemBaseComponent.attached$.next(null);
    }
}